import { RootState } from '@app/model';

export const selectExportIsLoading = ({ export: { exportIsLoading } }: RootState) => exportIsLoading;
export const selectModalIsOpen = ({ export: { isOpenExportModal } }: RootState) => isOpenExportModal;
export const selectExportedBookId = ({ export: { exportedBookId } }: RootState) => exportedBookId;
